import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useCurrency } from "@/context/CurrencyContext";

const CURS = ["INR", "USD", "EUR", "GBP", "AED"];

export const CurrencySelect = ({ testId = "currency-select", className = "w-[110px]" }) => {
  const { currency, setCurrency } = useCurrency();
  return (
    <Select value={currency} onValueChange={setCurrency}>
      <SelectTrigger data-testid={testId} className={`rounded-full ${className}`}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {CURS.map((c) => (
          <SelectItem key={c} value={c} data-testid={`currency-option-${c.toLowerCase()}`}>{c}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
